<ng-template #skillLevelMenu>
  <ul>
    @for (option of options(); track option.value) {
      <li
        [class.active]="option.value === selectedValue()"
        (click)="selectLevel(option.value)"
      >
        <p>{{ option.label | transloco }}</p>
      </li>
    }
  </ul>
</ng-template>
<ct-lib-dropdown
  [dropdown]="skillLevelMenu"
  [autowidth]="true"
  [closeOnClick]="true"
  alignment="left"
>
  <ct-lib-tag [deletable]="deletable()" [interactable]="true" (onDelete)="onDelete()">
    @if (name()) {
      {{ name() }} ({{ levelLabel() | transloco }})
    } @else {
      {{ levelLabel() | transloco }}
    }
    <ct-lib-rotating-chevron
      class="ms-1"
      [baseState]="ChevronState.DOWN"
      [toggledState]="ChevronState.UP"
      [toggle]="dropdown()?.openState() ?? false"
      [large]="true"
    />
  </ct-lib-tag>
</ct-lib-dropdown>
